export default function DocumentViewer({ file }) {
    if (!file) return null;

    const isPDF = file.type === 'application/pdf';
    const isImage = file.type.startsWith('image/');

    return (
        <div className="w-full">
            <div className="hidden lg:block">
                {isPDF ? (
                    <object
                        data={URL.createObjectURL(file)}
                        type="application/pdf"
                        width="100%"
                        height="600px"
                    >
                        Il browser non supporta la visualizzazione PDF.
                    </object>
                ) : isImage ? (
                    <img
                        src={URL.createObjectURL(file)}
                        alt="Anteprima documento"
                        className="w-full max-h-[600px] object-contain"
                    />
                ) : (
                    <p>Anteprima non disponibile per questo tipo di file</p>
                )}
            </div>
        </div>
    );
}
